import { useTranslation } from 'react-i18next';
import { useFxRate } from '../contexts';
import { formatPrice } from '../utils/formatPrice';

/**
 * 통화 표기 훅 — 가격 1건을 로케일에 맞는 완성 문자열로 반환한다.
 *
 *  · 한국어(ko)            → "139,000 원" (숫자와 '원' 사이 공백 1개)
 *  · 그 외 다국어 + 환율   → "US$ 101"    (정수 반올림, 표시 전용, "US$" 와 숫자 사이 공백 1개)
 *  · 환율 미로드/실패      → KRW 폴백("139,000 KRW" 등) → 회귀 없음
 *
 * 주의: 표시 전용. 실제 결제/계산 금액(KRW)에는 절대 사용하지 않는다.
 *
 * @returns {(amount: number|string) => string}
 */
export function useMoney() {
  const { t, i18n } = useTranslation();
  const { rate } = useFxRate();
  const lang = (i18n.language || 'ko').split('-')[0];

  return (amount) => {
    const n = Number(amount);
    // ko / 환율없음 / 숫자아님 → 현행 KRW 표기 그대로
    if (lang === 'ko' || !rate || !Number.isFinite(n)) {
      return `${formatPrice(amount)} ${t('common.won')}`;
    }
    return `US$ ${Math.round(n / rate).toLocaleString('en-US')}`;
  };
}
